import { apiInstance } from '@/api/api.js'
import Vue from 'vue'
import { tenantTexts } from '@/mixins/tenantTexts'
const api = apiInstance()

export default {
  async getExerciseDefinitions(
    { state, commit, dispatch },
    { params, loader = true, retry = 1, maxRetry = 3 },
  ) {
    const url = `/routines/definitions/items`

    params = params || state.exercisesFilters || new URLSearchParams()

    try {
      if (loader) commit('setLoading', true)
      const response = await api.get(url, { params })
      let processingMedia = response.data.items.filter(item => {
        return (
          item.exercise?.media?.processing ||
          item.series?.media?.processing ||
          item.activity?.media?.processing
        )
      })
      clearTimeout(state.reloadTimeoutExercises)
      if (processingMedia.length > 0 && retry) {
        let retNext = false
        let timeouts = [5, 25, 60]
        state.reloadTimeoutExercises = setTimeout(() => {
          if (retry < maxRetry) retNext = retry + 1
          dispatch('getExerciseDefinitions', {
            params: params,
            loader: false,
            retry: retNext,
          })
        }, timeouts[retry - 1] * 1000)
      }
      commit('setExerciseDefinitions', response.data.items)
      commit('setExercisesFilters', params)
      commit('setPagination', response.data._meta)
      if (loader) commit('setLoading', false)
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async getDialogExerciseDefinitions(
    { state, commit, dispatch },
    { params, loader = true, retry = 1, maxRetry = 3 },
  ) {
    const url = `/routines/definitions/items`
    params = params || state.dialogExercisesFilters || new URLSearchParams()
    try {
      if (loader) commit('setLoading', true)
      const response = await api.get(url, { params })
      let processingMedia = response.data.items.filter(item => {
        return item.single?.media?.processing
      })
      clearTimeout(state.reloadTimeoutDialogExercises)
      if (processingMedia.length > 0 && retry) {
        let retNext = false
        let timeouts = [5, 25, 60]
        state.reloadTimeoutDialogExercises = setTimeout(() => {
          if (retry < maxRetry) retNext = retry + 1
          dispatch('getDialogExerciseDefinitions', {
            params: params,
            loader: false,
            retry: retNext,
          })
        }, timeouts[retry - 1] * 1000)
      }
      commit('setDialogExerciseDefinitions', response.data.items)
      commit('setDialogExercisesFilters', params)
      commit('setDialogPagination', response.data._meta)
      if (loader) commit('setLoading', false)
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async moveExerciseItem({ state, commit, dispatch }, { itemId, data }) {
    let url = `/routines/definitions/items/${itemId}`
    try {
      commit('setLoading', true)
      await api.put(url, data)
      await dispatch('getExerciseDefinitions', {})
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', `Item moved!`, { root: true })
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async getSharedExerciseDefinitions({ state, commit, dispatch }, params) {
    const url = `/routines/definitions/items/shared`

    params = params || state.dialogExercisesFilters || new URLSearchParams()

    try {
      commit('setLoading', true)
      const response = await api.get(url, { params })
      commit('setDialogExerciseDefinitions', response.data.items)
      commit('setDialogExercisesFilters', params)
      commit('setDialogPagination', response.data._meta)
      commit('setLoading', false)
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async duplicateRoutinesDefinitionsItems({ state, commit, dispatch }, data) {
    const url = '/routines/definitions/items/copy'
    const itemsData = {
      items: data,
    }
    try {
      commit('setLoading', true)
      await api.post(url, itemsData)
      await dispatch('getExerciseDefinitions', {})
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', `Items duplicated!`, {
        root: true,
      })
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async getSharedExerciseDefinitionsCompanies(
    { state, commit, dispatch },
    params,
  ) {
    const url = `/routines/definitions/items/shared/company`

    params = params || new URLSearchParams()

    try {
      commit('setLoading', true)
      const response = await api.get(url, { params })
      commit('setSharingCompanies', response.data.items)
      commit('setDialogPagination', response.data._meta)
      commit('setLoading', false)
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async getSharedExerciseDefinitionsFromCompany(
    { state, commit, dispatch },
    { companyId, params },
  ) {
    const url = `/routines/definitions/items/shared/company/${companyId}`

    params = params || state.dialogExercisesFilters || new URLSearchParams()

    try {
      commit('setLoading', true)
      const response = await api.get(url, { params })
      commit('setDialogExerciseDefinitions', response.data.items)
      commit('setDialogExercisesFilters', params)
      commit('setDialogPagination', response.data._meta)
      commit('setLoading', false)
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async getExerciseDefinition({ commit, dispatch }, { id, type }) {
    let url = `/routines/definitions/exercises/${id}`
    if (type == 'SERIES') url = `/routines/definitions/series/${id}`
    else if (type == 'ACTIVITY') url = `/routines/definitions/activities/${id}`

    try {
      commit('setLoading', true)
      const response = await api.get(url)
      response.data.type = type
      commit(
        'headersStates/setHeadersEtag',
        { headers: response.headers, url },
        { root: true },
      )
      commit('setExerciseDefinition', response.data)
      commit('appStates/setBreadcrumbCurrentView', response.data.name, {
        root: true,
      })
      commit('setLoading', false)
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async addExerciseDefinition({ commit, dispatch }, { data }) {
    let url = `/routines/definitions/exercises`
    let label = 'single exercise'
    const savedType = data.type
    if (data.type == 'SERIES') {
      url = `/routines/definitions/series`
      label = 'Circuit'
      if (!data.restTimeAfterExercise) {
        data.restTimeAfterExercise = 0
      }
    } else if (data.type == 'ACTIVITY') {
      url = `/routines/definitions/activities`
      label = 'activity'
    }

    const {
      media = null,
      additionalMedia = null,
      currentAdditionalMedia,
      currentMedia,
      ...rest
    } = data

    const model = { ...rest }

    try {
      commit('setLoading', true)
      let formData = new FormData()
      delete model['type']

      let file = null

      if (media === null || media === undefined) {
        // do not change thumbnail
        model.media = null
      } else if (media?.mlSourceResourceId) {
        // select new thumbnail from media library
        model.media = { mlSourceResourceId: media?.mlSourceResourceId }
      } else if (media?.remove) {
        // remove thumbnail
        model.media = { remove: true }
      } else {
        // upload new thumbnail from local device
        file = media.file
      }

      // Additional Media
      let additionalFile = null

      if (additionalMedia === null || additionalMedia === undefined) {
        // do not change thumbnail
        model.additionalMedia = null
      } else if (additionalMedia?.mlSourceResourceId) {
        // select new thumbnail from media library
        model.additionalMedia = {
          mlSourceResourceId: additionalMedia?.mlSourceResourceId,
        }
      } else if (additionalMedia?.remove) {
        // remove thumbnail
        model.additionalMedia = { remove: true }
      } else {
        // upload new thumbnail from local device
        additionalFile = additionalMedia.file
      }

      formData.append(
        'model',
        new Blob([JSON.stringify(model)], {
          type: 'application/json',
        }),
      )

      if (file) {
        formData.append(
          'file',
          new Blob([file], {
            type: 'application/octet-stream',
          }),
          media?.file?.name || file.name,
        )
      }

      if (additionalFile) {
        formData.append(
          'additionalFile',
          new Blob([additionalFile], {
            type: 'application/octet-stream',
          }),
          additionalMedia?.file?.name || additionalFile.name,
        )
      }
      const response = await api.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      await dispatch('getExerciseDefinition', {
        id: response.data.id,
        type: savedType,
      })
      await dispatch('getExerciseDefinitions', {})
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', `New ${label} added!`, {
        root: true,
      })
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async deleteExerciseDefinition(
    { commit, dispatch, rootState },
    { id, type = 'EXERCISE' },
  ) {
    let url = `/routines/definitions/exercises/${id}`
    if (type == 'SERIES') url = `/routines/definitions/series/${id}`
    else if (type == 'ACTIVITY') url = `/routines/definitions/activities/${id}`
    try {
      const { headersStates } = rootState
      commit('setLoading', true)
      await api.delete(url, {
        headers: { 'If-Match': headersStates.headersEtag[url] },
      })
      await dispatch('getExerciseDefinitions', {})
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Exercise deleted!', {
        root: true,
      })
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async changeExerciseDefinition(
    { state, commit, rootState, dispatch },
    { data },
  ) {
    const {
      media = null,
      additionalMedia = null,
      currentAdditionalMedia,
      currentMedia,
      id,
      type,
      ...rest
    } = data

    let url = `/routines/definitions/exercises/${id}`
    if (type == 'SERIES') url = `/routines/definitions/series/${id}`
    else if (type == 'ACTIVITY') url = `/routines/definitions/activities/${id}`

    const model = { ...rest }

    if (type == 'SERIES' && !rest.restTimeAfterExercise) {
      model.restTimeAfterExercise = 0
    }

    try {
      const { headersStates } = rootState
      delete model['id']
      delete model['type']
      commit('setLoading', true)
      let formData = new FormData()

      let file = null

      if (!media?.file && !media?.mlSourceResourceId && !media?.remove) {
        // do not change thumbnail
        model.media = null
      } else if (media?.mlSourceResourceId) {
        // select new thumbnail from media library
        model.media = { mlSourceResourceId: media?.mlSourceResourceId }
      } else if (media?.remove) {
        // remove thumbnail
        model.media = { remove: true }
      } else {
        // upload new thumbnail from local device
        file = media.file
      }

      // Additional Media
      let additionalFile = null

      if (
        !additionalMedia?.file &&
        !additionalMedia?.mlSourceResourceId &&
        !additionalMedia?.remove
      ) {
        // do not change thumbnail
        model.additionalMedia = null
      } else if (additionalMedia?.mlSourceResourceId) {
        // select new thumbnail from media library
        model.additionalMedia = {
          mlSourceResourceId: additionalMedia?.mlSourceResourceId,
        }
      } else if (additionalMedia?.remove) {
        // remove thumbnail
        model.additionalMedia = { remove: true }
      } else {
        // upload new thumbnail from local device
        additionalFile = additionalMedia.file
      }

      formData.append(
        'model',
        new Blob([JSON.stringify(model)], {
          type: 'application/json',
        }),
      )

      if (file) {
        formData.append(
          'file',
          new Blob([file], {
            type: 'application/octet-stream',
          }),
          media?.file?.name || file.name,
        )
      }

      if (additionalFile) {
        formData.append(
          'additionalFile',
          new Blob([additionalFile], {
            type: 'application/octet-stream',
          }),
          additionalMedia?.file?.name || additionalFile.name,
        )
      }

      const response = await api.put(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'If-Match': headersStates.headersEtag[url],
        },
      })
      commit('setExerciseDefinition', response.data)
      commit('appStates/setBreadcrumbCurrentView', response.data.name, {
        root: true,
      })
      commit(
        'headersStates/setHeadersEtag',
        { headers: response.headers, url },
        { root: true },
      )
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Saved!', { root: true })
      await dispatch('getExerciseDefinitions', {})
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      await dispatch('getExerciseDefinition', { id: id, type: type })
      commit('setLoading', false)
    }
  },
  async shareExerciseDefinition(
    { rootState, commit, dispatch },
    { exerciseId, type, folderId = false, company = false },
  ) {
    let modifiedExerciseId = exerciseId
    if (typeof exerciseId == 'string' && exerciseId.includes('__'))
      modifiedExerciseId = parseInt(exerciseId.split('__')[1])
    let companyStr = ''
    if (company) companyStr = 'company/'
    let url = `/routines/definitions/exercises/${modifiedExerciseId}/shared/${companyStr}copy`
    if (type == 'SERIES')
      url = `routines/definitions/series/${modifiedExerciseId}/shared/${companyStr}copy`
    else if (type == 'ACTIVITY')
      url = `routines/definitions/activities/${modifiedExerciseId}/shared/${companyStr}copy`

    let data = {}
    if (folderId) data.folderId = folderId

    try {
      const { headersStates } = rootState

      commit('setLoading', true)
      await api.post(url, data)
      if (!company) {
        await dispatch('getSharedExerciseDefinitions')
        await dispatch('getExerciseDefinitions', {})
      }
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Item imported!', {
        root: true,
      })
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async shareExerciseToPractice(
    { rootState, commit, dispatch },
    { exerciseId, type, practices },
  ) {
    let typeUrl = ''
    switch (type) {
      case 'EXERCISE':
        typeUrl = 'exercises'
        break
      case 'SERIES':
        typeUrl = 'series'
        break
      case 'ACTIVITY':
        typeUrl = 'activities'
        break
      default:
        typeUrl = 'exercises'
        break
    }
    let url = `/routines/definitions/${typeUrl}/${exerciseId}/shared`
    try {
      const { headersStates } = rootState

      commit('setLoading', true)
      await api.post(url, { companyId: practices })
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Item shared!', {
        root: true,
      })
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async shareExerciseBack(
    { rootState, commit, dispatch },
    { exerciseId, type },
  ) {
    let typeUrl = ''
    switch (type) {
      case 'EXERCISE':
        typeUrl = 'exercises'
        break
      case 'SERIES':
        typeUrl = 'series'
        break
      case 'ACTIVITY':
        typeUrl = 'activities'
        break
      default:
        typeUrl = 'exercises'
        break
    }
    let url = `/routines/definitions/${typeUrl}/${exerciseId}/shared/company`
    try {
      const { headersStates } = rootState

      commit('setLoading', true)
      await api.post(url)
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Item shared!', {
        root: true,
      })
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async shareFolderItemsToPractice(
    { rootState, commit, dispatch },
    { folderId, practices },
  ) {
    let url = `/routines/definitions/folders/${folderId}/shared`
    try {
      const { headersStates } = rootState

      commit('setLoading', true)
      const response = await api.post(url, { companyId: practices })
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Shared successful', {
        root: true,
      })
      if (
        response &&
        response.data &&
        response.data.duplicatedCompanies &&
        response.data.duplicatedCompanies.length > 0
      ) {
        commit('setDuplicatedCompanies', response.data.duplicatedCompanies)
      }
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async getExerciseFolders({ rootState, commit, dispatch }) {
    const url = `/routines/definitions/folders`
    try {
      const { headersStates } = rootState

      const response = await api.get(url)
      commit('setExerciseFolders', response.data.items)
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
    }
  },
  async createNewExerciseFolder({ rootState, commit, dispatch }, { title }) {
    const url = `/routines/definitions/folders`

    try {
      const { headersStates } = rootState

      commit('setLoading', true)
      await api.post(url, { title: title })
      await dispatch('getExerciseFolders')
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Folder created!', {
        root: true,
      })
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async renameExerciseFolder({ rootState, commit, dispatch }, { id, title }) {
    const url = `/routines/definitions/folders/${id}`

    try {
      const { headersStates } = rootState

      commit('setLoading', true)
      await api.put(url, { title: title })
      await dispatch('getExerciseFolders')
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Folder renamed!', {
        root: true,
      })
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async removeExerciseFolder(
    { rootState, commit, dispatch },
    { id, completely },
  ) {
    let url = `/routines/definitions/folders/${id}`
    if (completely) url = `/routines/definitions/folders/${id}/completely`

    try {
      const { headersStates } = rootState

      commit('setLoading', true)
      await api.delete(url)
      await dispatch('getExerciseFolders')
      await dispatch('getExerciseDefinitions', {})
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Folder removed!', {
        root: true,
      })
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async duplicateExerciseFolder({ rootState, commit, dispatch }, folderId) {
    let url = `/routines/definitions/folders/${folderId}/copy`

    try {
      const { headersStates } = rootState

      commit('setLoading', true)
      await api.post(url)
      await dispatch('getExerciseFolders')
      await dispatch('getExerciseDefinitions', {})
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Folder duplicated!', {
        root: true,
      })
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async getSequenceDefinitions({ state, commit, dispatch }, params) {
    const url = `/routines/definitions/sequences`

    params = params || state.sequencesFilters

    try {
      commit('setLoading', true)
      const response = await api.get(url, { params })
      commit('setSequenceDefinitions', response.data.items)
      commit('setProfilePreviews', response.data.profilePreviews)
      commit(
        'profilePreviewsStates/setProfilePreviews',
        response.data.profilePreviews || [],
        {
          root: true,
        },
      )
      commit('setSequencesFilters', params)
      commit('setPagination', response.data._meta)
      commit('setLoading', false)
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async getSharedSequenceDefinitions({ state, commit, dispatch }, params) {
    const url = `/routines/definitions/sequences/shared`

    params = params || state.dialogSequencesFilters

    try {
      commit('setLoading', true)
      const response = await api.get(url, { params })
      commit('setDialogSequenceDefinitions', response.data.items)
      commit('setDialogSequencesFilters', params)
      commit('setDialogPagination', response.data._meta)
      commit('setLoading', false)
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async getSequenceDefinition(
    { state, commit, dispatch },
    { id, loader = true, retry = 1, maxRetry = 3 },
  ) {
    const url = `/routines/definitions/sequences/${id}`

    try {
      if (loader) commit('setLoading', true)
      const response = await api.get(url)
      let processingDays = response.data.days.filter(item => {
        let processingExercises = item.items.filter(exercise => {
          return (
            exercise.processing == true ||
            (exercise.media && exercise.media.processing == true)
          )
        })
        if (processingExercises.length > 0) return true
        else return false
      })
      clearTimeout(state.reloadTimeoutSequence)
      if (processingDays.length > 0 && retry) {
        let retNext = false
        let timeouts = [5, 25, 60]
        state.reloadTimeoutSequence = setTimeout(() => {
          if (retry < maxRetry) retNext = retry + 1
          dispatch('getSequenceDefinition', {
            id: id,
            loader: false,
            retry: retNext,
          })
        }, timeouts[retry - 1] * 1000)
      }
      commit(
        'headersStates/setHeadersEtag',
        { headers: response.headers, url },
        { root: true },
      )
      commit('setSequenceDefinition', response.data)
      commit('appStates/setBreadcrumbCurrentView', response.data.title, {
        root: true,
      })
      if (loader) commit('setLoading', false)
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async getSequenceDefinitionParticipants(
    { state, commit, dispatch },
    { id, loader = true },
  ) {
    const url = `/routines/definitions/sequences/${id}/participants`

    try {
      if (loader) commit('setLoadingSequenceDefinitionParticipants', true)
      const response = await api.get(url)

      commit(
        'setSequenceDefinitionParticipants',
        response.data?.now?.participants?.items || [],
      )
      commit('setProfilePreviews', {
        ...state.profilePreviews,
        ...(response.data.profilePreviews || []),
      })
      commit(
        'profilePreviewsStates/setProfilePreviews',
        response.data.profilePreviews || [],
        {
          root: true,
        },
      )
      if (loader) commit('setLoadingSequenceDefinitionParticipants', false)
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoadingSequenceDefinitionParticipants', false)
    }
  },
  async addSequenceDefinition({ commit, dispatch }, data) {
    const url = `/routines/definitions/sequences`

    try {
      commit('setLoading', true)
      const response = await api.post(url, data)
      commit('setSequenceDefinition', response.data)
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'New routine added!', {
        root: true,
      })
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async deleteSequenceDefinition({ rootState, commit, dispatch }, id) {
    const url = `/routines/definitions/sequences/${id}`

    try {
      const { headersStates } = rootState
      commit('setLoading', true)
      await api.delete(url, {
        headers: { 'If-Match': headersStates.headersEtag[url] },
      })
      await dispatch('getSequenceDefinitions')
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Routine deleted!', {
        root: true,
      })
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async changeSequenceDefinition(
    { rootState, commit, dispatch },
    { sequenceId, title },
  ) {
    const url = `/routines/definitions/sequences/${sequenceId}`

    try {
      const { headersStates } = rootState
      commit('setLoading', true)
      await dispatch('getSequenceDefinition', { id: sequenceId })
      await api.put(
        url,
        { title: title, rootFolder: true },
        { headers: { 'If-Match': headersStates.headersEtag[url] } },
      )
      await dispatch('getSequenceDefinitions')
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Routine renamed!', {
        root: true,
      })
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async duplicateSequenceDefinition(
    { rootState, commit, dispatch },
    sequenceId,
  ) {
    const url = `/routines/definitions/sequences/${sequenceId}/copy`

    try {
      const { headersStates } = rootState
      commit('setLoading', true)
      await api.post(url)
      await dispatch('getSequenceDefinitions')
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Routine duplicated!', {
        root: true,
      })
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async shareSequenceToPractice(
    { rootState, commit, dispatch },
    { sequenceId, practices },
  ) {
    const url = `/routines/definitions/sequences/${sequenceId}/shared`
    try {
      const { headersStates } = rootState

      commit('setLoading', true)
      await api.post(url, { companyId: practices })
      await dispatch('getSequenceDefinitions')
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Routine shared!', {
        root: true,
      })
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  /* sequence */
  async addExerciseToSequenceDefinition(
    { commit, dispatch },
    { sequenceId, exerciseId, type, day },
  ) {
    const url = `/routines/definitions/sequences/${sequenceId}/items`

    let tmpObj = {
      day: day,
    }
    let modifiedExerciseId = exerciseId
    if (typeof exerciseId == 'string' && exerciseId.includes('__'))
      modifiedExerciseId = parseInt(exerciseId.split('__')[1])

    if (type == 'SERIES') tmpObj.seriesDefinitionId = modifiedExerciseId
    else if (type == 'ACTIVITY')
      tmpObj.activityDefinitionId = modifiedExerciseId
    else tmpObj.exerciseDefinitionId = modifiedExerciseId

    try {
      commit('setLoading', true)
      await api.post(url, tmpObj)
      await dispatch('getSequenceDefinition', { id: sequenceId })
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Item added!', { root: true })
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async copySequenceExercises(
    { commit, dispatch },
    { sequenceId, items = [], start = 0, repetitions = 0, interval = 0 },
  ) {
    const url = `/routines/definitions/sequences/${sequenceId}/items/copy`

    try {
      commit('setLoading', true)
      const params = {
        start: parseInt(start, 10),
        repetitions: parseInt(repetitions, 10),
        interval: parseInt(interval, 10),
        items,
      }
      await api.post(url, params)
      await dispatch('getSequenceDefinition', { id: sequenceId })
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Items copied!', {
        root: true,
      })
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async duplicateSequenceExercise(
    { commit, dispatch },
    { sequenceId, itemId },
  ) {
    const url = `/routines/definitions/sequences/${sequenceId}/items/${itemId}/copy`

    try {
      commit('setLoading', true)
      await api.post(url)
      await dispatch('getSequenceDefinition', { id: sequenceId })
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Item duplicated!', {
        root: true,
      })
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async changeExerciseInSequenceDefinition(
    { rootState, commit, dispatch },
    { sequenceId, itemId, data },
  ) {
    const sequenceUrl = `/routines/definitions/sequences/${sequenceId}`
    const url = `/routines/definitions/sequences/${sequenceId}/items/${itemId}`
    try {
      const { headersStates } = rootState

      commit('setLoading', true)
      await api.put(url, data, {
        headers: { 'If-Match': headersStates.headersEtag[sequenceUrl] },
      })
      await dispatch('getSequenceDefinition', { id: sequenceId })
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Item moved!', { root: true })
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async removeExerciseFromSequenceDefinition(
    { rootState, commit, dispatch },
    { sequenceId, itemId },
  ) {
    const sequenceUrl = `/routines/definitions/sequences/${sequenceId}`
    const url = `/routines/definitions/sequences/${sequenceId}/items/${itemId}`

    try {
      const { headersStates } = rootState

      commit('setLoading', true)
      await api.delete(url, {
        headers: { 'If-Match': headersStates.headersEtag[sequenceUrl] },
      })
      await dispatch('getSequenceDefinition', { id: sequenceId })
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Item removed!', {
        root: true,
      })
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async removeExercisesFromSequenceDefinition(
    { commit, dispatch },
    { sequenceId, items = [] },
  ) {
    const url = `/routines/definitions/sequences/${sequenceId}/items/delete`

    try {
      commit('setLoading', true)
      const params = {
        items,
      }
      await api.post(url, params)
      // Do not get new sequence definition here, because we use dragSelector, so we need to uncheck
      // selected items on success remove before get new sequence
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Items removed!', {
        root: true,
      })
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async shareSequenceDefinition(
    { rootState, commit, dispatch },
    { sequenceId, folderId = false },
  ) {
    const url = `/routines/definitions/sequences/${sequenceId}/shared/copy`

    try {
      const { headersStates } = rootState

      let data = {}
      if (folderId) data.folderId = folderId

      commit('setLoading', true)
      await api.post(url, data)
      await dispatch('getSequenceDefinitions', {})
      await dispatch('getSharedSequenceDefinitions')
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Routine imported!', {
        root: true,
      })
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async assignSequence({ commit, dispatch }, { sequenceId, data }) {
    const url = `/routines/definitions/sequences/${sequenceId}/assign`

    try {
      commit('setLoading', true)
      const response = await api.post(url, data)
      commit('setLoading', false)
      commit(
        'appStates/setSnackbarNotification',
        tenantTexts.applySequence.successMessage,
        { root: true },
      )
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async getSequenceFolders({ rootState, commit, dispatch }) {
    const url = `/routines/definitions/sequences/folders`
    try {
      const { headersStates } = rootState

      const response = await api.get(url)
      commit('setSequenceFolders', response.data.items)
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
    }
  },
  async createNewSequenceFolder({ rootState, commit, dispatch }, { title }) {
    const url = `/routines/definitions/sequences/folders`

    try {
      const { headersStates } = rootState

      commit('setLoading', true)
      await api.post(url, { title: title })
      await dispatch('getSequenceFolders')
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Folder created!', {
        root: true,
      })
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async renameSequenceFolder({ rootState, commit, dispatch }, { id, title }) {
    const url = `/routines/definitions/sequences/folders/${id}`

    try {
      const { headersStates } = rootState

      commit('setLoading', true)
      await api.put(url, { title: title })
      await dispatch('getSequenceFolders')
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Folder renamed!', {
        root: true,
      })
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async removeSequenceFolder(
    { rootState, commit, dispatch },
    { id, completely },
  ) {
    let url = `/routines/definitions/sequences/folders/${id}`
    if (completely)
      url = `/routines/definitions/sequences/folders/${id}/completely`

    try {
      const { headersStates } = rootState

      commit('setLoading', true)
      await api.delete(url)
      await dispatch('getSequenceFolders')
      await dispatch('getSequenceDefinitions', {})
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Folder removed!', {
        root: true,
      })
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async moveSequenceItem({ state, commit, dispatch }, { itemId, data }) {
    let url = `/routines/definitions/sequences/${itemId}/folder`
    try {
      commit('setLoading', true)
      await api.put(url, data)
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', `Item moved!`, { root: true })
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  clearGetExerciseDefinitionsDialogTimeout({ state }) {
    clearTimeout(state.reloadTimeoutDialogExercises)
  },
  async createExercisesFromML(
    { state, commit, dispatch },
    { data, mlFile = null, participants = [], collect = false },
  ) {
    if (!participants || participants.length === 0 || !mlFile) {
      return
    }
    try {
      commit('setLoading', true)

      const body = {
        date:
          data.date || data.exerciseDay || Vue.moment().format('YYYY-MM-DD'),
        participants,
        collect,
        title: data.title,
        description: data.description,
      }

      if (data.mobileStaticMedia)
        body.mobileStaticMedia = data.mobileStaticMedia
      if (data.externalUrl) body.externalUrl = data.externalUrl
      if (mlFile && mlFile.id) body.media = { mlSourceResourceId: mlFile.id }
      if (data.time) body.time = data.time
      if (data.weight) body.weight = data.weight
      if (data.repetitions) body.repetitions = data.repetitions
      if (data.series) body.series = data.series
      if (data.restTimeBetweenSeries)
        body.restTimeBetweenSeries = data.restTimeBetweenSeries
      if (data.restTimeAfterExercise || data.restTimeAfterExercise === 0)
        body.restTimeAfterExercise = data.restTimeAfterExercise
      if (data.distance) body.distance = data.distance
      if (data.externalUrl) body.externalUrl = data.externalUrl

      const response = await api.post('/routines/exercises', body)
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', `Single exercise added!`, {
        root: true,
      })
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async createActivitiesFromML(
    { state, commit, dispatch },
    { data, mlFile = null, participants = [], collect = false },
  ) {
    if (!participants || participants.length === 0 || !mlFile) {
      return
    }
    try {
      commit('setLoading', true)

      const body = {
        date:
          data.date || data.exerciseDay || Vue.moment().format('YYYY-MM-DD'),
        participants,
        collect,
        title: data.title,
        description: data.description,
      }

      if (data.mobileStaticMedia)
        body.mobileStaticMedia = data.mobileStaticMedia
      if (data.externalUrl) body.externalUrl = data.externalUrl
      if (mlFile && mlFile.id) body.media = { mlSourceResourceId: mlFile.id }
      if (data.time) body.time = data.time
      if (data.externalUrl) body.externalUrl = data.externalUrl

      const response = await api.post('/routines/activities', body)
      commit('setLoading', false)
      commit(
        'appStates/setSnackbarNotification',
        tenantTexts.library.successCreateActivity,
        {
          root: true,
        },
      )
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async getRoutineDefinitionFoldersSharedList(
    { state, commit, dispatch },
    params,
  ) {
    const url = `/routines/definitions/folders/shared`

    params = params || state.dialogExercisesFilters || new URLSearchParams()

    const paramsFolderId = params.get('folderId')
    const paramsFilter = params.get('filter')

    if (paramsFolderId && paramsFilter !== 'all') {
      return
    }

    const folderParams = {
      folderSharedStrategy: params.get('filter').toUpperCase(),
    }

    const searchParams = new URLSearchParams(folderParams)

    try {
      const response = await api.get(url, { params: searchParams })
      commit('setRoutineDefinitionFoldersSharedList', response.data.items)
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
    }
  },
  async shareFolderDefinition({ rootState, commit, dispatch }, { folderId }) {
    let url = `/routines/definitions/folders/${folderId}/shared/copy`

    try {
      commit('setLoading', true)
      await api.post(url)
      await dispatch('getRoutineDefinitionFoldersSharedList')
      await dispatch('getSharedExerciseDefinitions')
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Item imported!', {
        root: true,
      })
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },
  async copyMultipleItemsSharedDefinitions(
    { rootState, commit, dispatch },
    { items, folderId },
  ) {
    let url = `/routines/definitions/items/shared/copy`
    try {
      const { headersStates } = rootState
      commit('setLoading', true)
      await api.post(url, { items: items, folderId: folderId })
      await dispatch('getRoutineDefinitionFoldersSharedList')
      await dispatch('getSharedExerciseDefinitions')
      commit('setLoading', false)
      commit('appStates/setSnackbarNotification', 'Items imported!', {
        root: true,
      })
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setLoading', false)
    }
  },

  // async sharePractices ({ commit, dispatch, rootState }, {id, practices}) {
  //   const url = `/messages/templates/${id}`
  //   try {
  //     const { headersStates } = rootState
  //     commit('setLoading', true)
  //     const response = await api.post(url+`/share`, {practices: practices},
  //       { headers: { "If-Match": headersStates.headersEtag[url] }})
  //     await dispatch('getTemplate', id)
  //     commit('setLoading', false)
  //     commit('appStates/setSnackbarNotification', 'Sprint shared!', { root: true })
  //   }
  //   catch (error) {
  //     dispatch('appStates/setErrorMessage', error,{ root: true })
  //     commit('setLoading', false)
  //   }
  // },

  // async applyTemplateOnParticipant ({ state, commit, dispatch, rootState }, {id, templateId, startDate}) {
  //   const url = `/messages/templates/${templateId}`
  //   try {
  //     const { headersStates } = rootState
  //     commit('setLoading', true)
  //     await dispatch('getTemplate', templateId)
  //     let params = {participantProfileId: id}
  //     if (startDate) params.startDate = startDate
  //     const response = await api.post(url+'/apply', params,
  //     { headers: { "If-Match": headersStates.headersEtag[url] }})
  //     commit('headersStates/setHeadersEtag', { headers: response.headers, url }, { root: true })
  //     let info = ''
  //     if (response.data.firstMessage) info = 'Sprint applied, first message is planned to be sent on '+ Vue.moment(response.data.firstMessage.plannedSendDateLocal).format("MM/DD/YYYY, hh:mm A") + '. '
  //     if (response.data.messageInPast) info += 'Some messages where created with a past date and will not be sent.'
  //     if (info !== '') commit('appStates/setSnackbarNotification', info, { root: true })
  //     commit('setLoading', false)
  //   }
  //   catch (error) {
  //     dispatch('appStates/setErrorMessage', error,{ root: true })
  //     commit('setLoading', false)
  //   }
  // },
}
